<template>
  <div class="content-box">
<!--    <div class="top" v-if="packageSnapshot.isSoldOut">-->
<!--      <div class="top-text" >-->
<!--        <img src="@/assets/img/top_icon_news.png" alt="">-->
<!--        <div class="text">您当前的套餐已下架，请重新选择其他套餐进行升级</div>-->
<!--        &lt;!&ndash;        <img src="@/assets/img/top_icon_arrow_red.png" alt="">&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
    <div class="center-box1">
      <div class="center-title">激活续费</div>
      <div class="center-hint">您当前版本类型：<span class="text">{{ packageSnapshot.typeStr }}</span>有效期至：<span
        class="time">{{ packageSnapshot.effectTime }}({{getRestOfDay(packageSnapshot.effectTime)}}）</span></div>
      <div class="flex">
        <div class="flex-box flex-box-active">
          <div class="flex-box-top">
            <div class="flex-box-top-title">{{ packageSnapshot.name }}</div>
<!--            <div class="flex-box-top-text">开通分销功能享受粉丝裂变高级功</div>-->
          </div>
          <div class="flex-box-center">
            <div class="flex-box-center-title">{{ packageSnapshot.price }}<span>元/{{ packageSnapshot.num }}{{packageSnapshot.dateTypeStr}}</span></div>
<!--            <div class="flex-box-center-text">利润分佣{{ packageSnapshot.commissionRate }}%</div>-->
          </div>
          <img class="current-img" src="@/assets/img/official/dangqian.png" alt="">
          <div class="flex-box-button" @click="goPay(packageSnapshot,3,3,1)" v-if="packageSnapshot.isSoldOut == 0 && packageSnapshot.isSupport == 1">
            续费
          </div>
          <!--          <div class="flex-box-hint">小试牛刀</div>-->
        </div>
<!--        <div class="flex-box" v-for="(item,index) in packageList" :key="index" :class="packageSnapshot.packageId == item.id?'flex-box-active':''">-->
<!--          <div class="flex-box-top">-->
<!--            <div class="flex-box-top-title">{{ item.name }}</div>-->
<!--            <div class="flex-box-top-text">开通分销功能享受粉丝裂变高级功</div>-->
<!--          </div>-->
<!--          <div class="flex-box-center">-->
<!--            <div class="flex-box-center-title">{{ item.price }}<span>元/{{ item.num }}{{ item.dateTypeStr }}</span>-->
<!--            </div>-->
<!--            <div class="flex-box-center-text">利润分佣{{ item.commissionRate }}%</div>-->
<!--          </div>-->
<!--          <div class="flex-box-button" @click="goPay(item,1,1)" v-if="packageSnapshot.isOver == 0 ">-->
<!--            补差升级-->
<!--          </div>-->
<!--          <div class="flex-box-button" @click="goPay(item,1,4)" v-if="packageSnapshot.isOver == 1">-->
<!--            立即开通-->
<!--          </div>-->
<!--          <div class="flex-box-hint">{{ item.tag }}</div>-->
<!--        </div>-->
      </div>
<!--      <div class="flex-text">-->
<!--        基础版举例：小A关注了您的公众号，打开您的影票专属推广链接，通过竞价方式购买了2张电影票支付100元，扣除影票成本和技术服务费，订单剩余利润10元。订单放映2小时后结算，您获得70%的利润分佣，即70%*10元=7元。-->
<!--      </div>-->
<!--      <div class="flex-span">套餐升级：将当前使用的套餐的剩余天数，按照价格比例进行对应折算升级为所选套餐。</div>-->
<!--      <div class="title" v-if="profitPackageSnapshot.effectTime">高级进阶<span>（开通分销功能，享受粉丝裂变高级功能</span></div>-->
<!--      <div class="center-hint" v-if="profitPackageSnapshot.effectTime">您当前版本类型：<span class="text">{{ profitPackageSnapshot.typeStr }}</span>有效期至：<span-->
<!--        class="time">{{ profitPackageSnapshot.effectTime }}({{getRestOfDay(profitPackageSnapshot.effectTime)}}）</span></div>-->
<!--      <div class="flex">-->
<!--        <div class="flex-box flex-box-active" v-if="profitPackageSnapshot.effectTime">-->
<!--          <div class="flex-box-top">-->
<!--            <div class="flex-box-top-title">{{ profitPackageSnapshot.name }}</div>-->
<!--            <div class="flex-box-top-text">开通分销功能享受粉丝裂变高级功</div>-->
<!--          </div>-->
<!--          <div class="flex-box-center">-->
<!--            <div class="flex-box-center-title">{{ profitPackageSnapshot.price }}<span>元/{{ profitPackageSnapshot.num }}天</span></div>-->
<!--            <div class="flex-box-center-text">利润分佣{{ profitPackageSnapshot.commissionRate }}%</div>-->
<!--          </div>-->
<!--          &lt;!&ndash;          <div class="flex-box-hint">小试牛刀</div>&ndash;&gt;-->
<!--          <img class="current-img" src="@/assets/img/official/dangqian.png" alt="">-->
<!--          <div class="flex-box-button" @click="goPay(profitPackageSnapshot,3,3,2)" v-if="profitPackageSnapshot.isSoldOut == 0 && profitPackageSnapshot.isSupport == 1">-->
<!--            续费-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="flex-box" :class="profitPackageSnapshot.packageId == item.id?'flex-box-active':''" v-for="(item,index) in packageProfitList">-->
<!--          <div class="flex-box-top">-->
<!--            <div class="flex-box-top-title">{{ item.name }}</div>-->
<!--            <div class="flex-box-top-text">开通分销功能享受粉丝裂变高级功</div>-->
<!--          </div>-->
<!--          <div class="flex-box-center">-->
<!--            <div class="flex-box-center-title">{{ item.price }}<span>元/{{ item.num }}{{item.dateTypeStr}}</span></div>-->
<!--&lt;!&ndash;            <div class="flex-box-center-text">利润分佣{{ item.commissionRate }}%</div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="flex-box-button" @click="goPay(item,2,1)" v-if="profitPackageSnapshot.isOver == 0">-->
<!--            补差升级-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="flex-box-button" @click="goPay(item,2,3)" v-if="profitPackageSnapshot.isSupport == 1">&ndash;&gt;-->
<!--&lt;!&ndash;            续费&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="flex-box-button" @click="goPay(item,2,4)" v-if="profitPackageSnapshot.isOver == 1 || !profitPackageSnapshot.effectTime">-->
<!--            立即开通-->
<!--          </div>-->
<!--          &lt;!&ndash;          <div class="flex-box-hint">小试牛刀</div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex-text">-->
<!--        分销功能举例：您的粉丝小A推广了小B注册，小B下单后小A可以得到一笔推广佣金（佣金比例由您自己设置）。小B再邀请小C注册下单，小B可以得到一级推广佣金，小A得到二级推广佣金。这样您的公众号系统就具备分销高级功能，粉丝裂变的更快，产生的订单收益越多。平均收益能比普通版本高出100%以上。-->
<!--      </div>-->
<!--      <div class="title">版本对比</div>-->
<!--      <Table style="margin-top: 40px" border :columns="columns" :data="list"></Table>-->
    </div>
    <activation-item ref="ActivationItem"></activation-item>
  </div>
</template>

<script>
import {Table} from 'view-design'
import checkRed from '@/assets/img/official/arrow_red.png'
import mini from "@/api/mini";
import ActivationItem from '@/views/pc/channelMiniProgram/dialog/index.vue'
const MiniModel = new mini()
import {getPlatformUuid} from '@/utils/auth'
export default {
  components: {
    Table,
    ActivationItem
  },
  name: "index",
  data() {
    return {
      columns: [
        {
          title: '功能',
          key: 'fun'
        },
        {
          title: '基础版',
          key: 'basic',
          render: (h, params) => {
            let iconName = params.row.basic
            let renderData = []
            if (iconName) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: iconName,
                    width: 20
                  },
                })
              )
            }
            return renderData
          }
        },
        {
          title: '分销版',
          key: 'distribution',
          render: (h, params) => {
            let iconName = params.row.distribution
            let renderData = []
            if (iconName) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: iconName,
                    width: 20
                  },
                })
              )
            }
            return renderData
          }
        }
      ],
      list: [
        {
          'fun': '获取全国影院信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '获取最新影片信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '获取即将上映影片信息',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '秒出票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '特惠购票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '竞价购票功能',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '绑定小程序',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '订单报表',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '推广素材库',
          'basic': checkRed,
          'distribution': checkRed
        },
        {
          'fun': '用户裂变模块',
          'basic': '',
          'distribution': checkRed
        },
        {
          'fun': '自定义邀请海报',
          'basic': '',
          'distribution': checkRed
        }
      ],
      packageList: [], // 基础套餐
      packageProfitList: [], // 分销套餐
      appKey: '',
      packageSnapshot: {}, // 基础套餐信息
      profitPackageSnapshot: {},// 分销套餐信息
      show:false
    }
  },
  mounted() {
    this.appKey = localStorage.getItem('appKeyMini')
    this.getList()
  },
  methods: {
    // 获取套餐列表
    getList() {
      let param = {
        appKey: this.appKey,
        channelType:7
        // client:4
      }
      MiniModel.getSetList(param).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.packageList = res.data.data.packageList
          this.packageProfitList = res.data.data.packageProfitList
          this.packageSnapshot = res.data.data.packageSnapshot
          console.log('res.data.data.profitPackageSnapshot',res.data.data.profitPackageSnapshot)
          if(res.data.data.profitPackageSnapshot != null){
            this.profitPackageSnapshot = res.data.data.profitPackageSnapshot
            this.show = true
          }else {
            this.show = false
          }
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    goPay(item,index,type,diff) {
      if (index === 1) {
        this.$router.push({
          path: '/pc/channelMiniProgram/pay',
          query: {
            // platformUuid: getPlatformUuid(),
            isProfit: 1,
            packageId: item.id,
            type: type,
            snapshotId: 0,
            appKey: localStorage.getItem('appKeyMini'),
          }
        })
      }
      if(index === 2){
        this.$router.push({
          path: '/pc/channelMiniProgram/pay',
          query: {
            // platformUuid: getPlatformUuid(),
            isProfit: 1,
            // packageId: this.packageSnapshot.packageId,
            type: type,
            snapshotId: 0,
            appKey: localStorage.getItem('appKeyMini'),
            profitPackageId:item.id,
            isProfitType:1
          }
        })
      }
      if(index === 3){
       let query;
        if(diff === 1){
          query = {
            // platformUuid: getPlatformUuid(),
            isProfit: 1,
            packageId: item.packageId,
            type: type,
            snapshotId: 0,
            appKey: localStorage.getItem('appKeyMini'),
          }
        }else {
          query = {
            // platformUuid: getPlatformUuid(),
            isProfit: 1,
            type: type,
            snapshotId: 0,
            appKey: localStorage.getItem('appKeyMini'),
            profitPackageId:item.packageId
          }
        }
        this.$router.push({
          path: '/pc/channelMiniProgram/pay',
          query: query
        })
      }
      // 如果是购买分销且基础套餐过期了显示弹窗
      if(this.packageSnapshot.isOver == 1 && index === 2){
        let isProfitInt = 1
        this.$refs.ActivationItem.init(this.packageList, item, isProfitInt, item)
      }
    },
    // 获取剩余天数
    // getDays() {
    //   //转成时间戳然后计算时间
    //   let time = Date.parse(new Date(this.packageSnapshot.effectTime));
    //   let timeFx = Date.parse(new Date(this.profitPackageSnapshot.effectTime))
    //   let day = parseInt(time - Date.parse(new Date())) / (1000 * 60 * 60 * 24)
    // },
    // 获取剩余天数
    getRestOfDay(createTime){
      let _d_tm = new Date(new Date().valueOf());
      let _d_now = new Date(new Date().valueOf());
      if(createTime){
        _d_now = new Date((createTime).replace(/-/g, "/"));
      }
      if(_d_now<_d_tm){
        return '已过期'
      }
      let leftTime =  ~~((_d_now - _d_tm) / 1000 / 60 / 60 / 24);
      return  leftTime+'天'
    },
  }
}
</script>

<style scoped lang="less">
.content-box {
  width: 100%;

  .top {
    height: 40px;
    background: #FFF6F8;
    border-radius: 4px;
    border: 1px solid #FFCAD5;
    width: 100%;
    margin-bottom: 10px;

    .top-text {
      height: 40px;
      display: flex;
      align-items: center;
      margin-left: 16px;

      .text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;

        span {
          color: #FF4F76;
        }
      }
    }
  }

  .center-box1 {
    width: 99%;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;

    .center-title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
    }

    .center-hint {
      height: 48px;
      background: #FAFAFA;
      border-radius: 4px;
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 48px;
      padding: 0 20px;
      margin-top: 20px;

      .text {
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 22px;
        margin-right: 40px;
      }

      .time {
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #3D9EFC;
        line-height: 22px;
      }
    }
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 40px;
  .flex-box-active{
    background: rgb(255, 251, 247)!important;
    border: 1px solid rgb(255, 134, 34)!important;
    color: rgb(255, 134, 34)!important;
  }
  .flex-box {
    // width: 265px;
    max-width: 355px;
    min-width: 265px;
    height: 323px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    padding: 18px 20px;
    text-align: center;
    position: relative;
    margin-top: 40px;

    .flex-box-top {
      border-bottom: 1px solid #EEEEEE;

      .flex-box-top-title {
        font-size: 20px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 27px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .flex-box-top-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 20px;
        margin-top: 8px;
        padding-bottom: 18px;
      }
    }

    .flex-box-center {
      margin-top: 30px;

      .flex-box-center-title {
        font-size: 32px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 44px;

        span {
          font-size: 16px;
        }
      }

      .flex-box-center-text {
        font-size: 18px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 25px;
        margin-top: 10px;
      }
    }

    .flex-box-button {
      //width: 205px;
      height: 42px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 42px;
      text-align: center;
      margin-top: 40px;
      cursor: pointer;
    }

    .flex-box-hint {
      width: 68px;
      height: 20px;
      background: #FF4F76;
      border-radius: 4px 0 4px 0;
      text-align: center;
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      position: absolute;
      left: 0;
      top: 0;
      line-height: 20px;
    }
  }
}

.flex-text {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 20px;
  margin-top: 7px;
}

.flex-span {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 20px;
}

.title {
  font-size: 20px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  line-height: 27px;
  margin-top: 40px;

  span {
    color: #999999 !important;
  }
}

.flex:after {
  content: '';
  width: 285px;
}
.current-img{
  position: absolute;
  bottom: -1px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/activate/index.vue